import styled, { css } from 'styled-components';
import { lg } from '@exonet/react-shared/lib/styled';

export const Container = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  max-width: 100vw;
  margin-top: 50px;

  ${lg(css`
    margin-top: 0;

    ${({ authorized }) =>
      authorized &&
      css`
        max-width: calc(100% - 250px);
      `}
  `)}
`;

export const Content = styled.section`
  flex: 1 1 auto;
  padding: var(--xs-padding);

  ${lg(css`
    padding: var(--lg-padding);
  `)}

  form {
    box-shadow: var(--form-box-shadow, var(--box-shadow));
  }
`;

export const ButtonWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  inset: 0;
  z-index: 1000;
  pointer-events: none;
`;

export const MenuButton = styled.button.attrs({
  type: 'button',
})`
  position: relative;
  width: 26px;
  height: 50px;
  background: transparent;
  border: none;
  cursor: pointer;
  pointer-events: auto;
  padding: 0;
  margin: 0;
  outline: none !important;
  display: flex;
  align-items: center;

  &:focus,
  :active,
  :hover,
  :visited {
    background-color: transparent;
  }

  ${({ authorized }) =>
    !authorized &&
    css`
      display: none;
    `};

  > div {
    position: relative;
    width: 100%;
    height: 15px;

    > span {
      position: absolute;
      left: 0;
      width: 100%;
      height: 0.1rem;
      background: var(--text);
      border-radius: 2px;
      transition:
        transform 0.5s ease,
        opacity 0.3s ease,
        background-color 0.3s ease;

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2) {
        top: 7px;
      }

      &:nth-child(3) {
        top: 14px;
      }

      ${({ open }) =>
        open &&
        css`
          background-color: var(--menu-text-active);

          &:nth-child(1) {
            transform: rotate(45deg);
            top: 7px;
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:nth-child(3) {
            transform: rotate(-45deg);
            top: 7px;
          }
        `};
    }

    ${lg(css`
      display: none;
    `)}
  }
`;

export const NewVersionLink = styled.a`
  cursor: pointer;
`;
